import React from 'react';

import { Label, TONE_COLOR, type BadgeTone } from './Badge.styles';

export type { BadgeTone };
export { TONE_COLOR as BADGE_TONE_COLOR } from './Badge.styles';

export type BadgeProps = {
  label: string;
  tone?: BadgeTone;
  className?: string;
};

/** Small coloured text label (status pill). Tone maps to a token colour. */
export const Badge = ({ label, tone = 'neutral', className }: BadgeProps): React.ReactElement => (
  <Label text={label} tag="span" $color={TONE_COLOR[tone]} className={className} />
);

export default Badge;
